module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_ceremonyimage-9cf68e6bf691564596294cb4a5eda3d3.jpg";